module.exports = __webpack_public_path__ + "media/images/logo_gold-ba188d7e.svg";